import { render, staticRenderFns } from "./InnerTabs.vue?vue&type=template&id=87e97d10&scoped=true"
import script from "./InnerTabs.vue?vue&type=script&lang=js"
export * from "./InnerTabs.vue?vue&type=script&lang=js"
import style0 from "./InnerTabs.vue?vue&type=style&index=0&id=87e97d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e97d10",
  null
  
)

export default component.exports